import React, { useState, useEffect, useRef } from "react";
import "./StackedGallery.css";

import gallery1 from "../assets/gal1.jpg";
import gallery2 from "../assets/gal2.jpg";
import gallery3 from "../assets/gal3.jpg";
import gallery4 from "../assets/gal4.jpg";
import gallery5 from "../assets/gal5.jpg";
import gallery6 from '../assets/gal6.jpg'  

// Default images used as fallback
const defaultImages = [
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
];

const StackedGallery = ({ images = [], title = 'Our Memories' }) => {
  const galleryImages = (Array.isArray(images) && images.length > 0) ? images : defaultImages;
  const [current, setCurrent] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const timerRef = useRef(null);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (!touchStartX) return;
    const diff = touchStartX - e.touches[0].clientX;

    if (diff > 50) {
      nextSlide();
      setTouchStartX(null);
    }
    if (diff < -50) {
      prevSlide();
      setTouchStartX(null);
    }
  };

  const handleTouchEnd = () => {
    setTouchStartX(null);
  };

  useEffect(() => {
    timerRef.current = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => clearInterval(timerRef.current);
  }, []);

  const handleManualChange = (index) => {
    setCurrent(index);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      nextSlide();
    }, 4000);
  };

  return (
    <section className="carousel-section">
      <h2 className="section-head">{title || 'Our Memories'}</h2>

      <div
        className="carousel-wrapper"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="carousel-track">
          {galleryImages.map((img, index) => {
            const position = (index - current + galleryImages.length) % galleryImages.length;
            let className = "carousel-image";

            if (position === 0) className += " prev";
            else if (position === 1) className += " active";
            else if (position === 2) className += " next";
            else className += " hidden";

            return (
              <a href="/gallery" key={`sg-${index}`}>
                <img
                  src={img}
                  alt={`Slide ${index + 1}`}
                  className={className}
                  loading="lazy"
                  decoding="async"
                />
              </a>
            );
          })}
        </div>
      </div>

      {/* ✅ NEW GALLERY BUTTON */}
      <div className="gallery-btn-wrapper">
        <a href="/gallery" className="gallery-btn">
          View Full Gallery
        </a>
      </div>
    </section>
  );
};

export default StackedGallery;
